import React, { Component } from 'react'

export default class Recipes extends Component {
    render() {
        return (
            <div className="App">
                <h1>Recipes !</h1>
            </div>
        )
    }
}
